import { url } from "../../common/config";
export const baseUrl = url;